import { GetDocumentsReferenceOutputDto } from '@api/izibizi-xp';
import {
	useFetchSoftwareRetrieveDocumentsReference,
	useFetchBankRetrieveDocumentsReference,
	useFetchBankInsuranceDocumentReference,
	useFetchBankInsurancePersonalDocumentReference,
} from '@services';
import { useServiceResponse } from '@store';

interface UseFetchDocumentInput {
	reference: string | undefined;
}

interface useFetchDocumentOutput {
	base64SoftwareDocument?: string;
	base64BankDocument?: string;
	base64InsurancePersonalDocument?: string;
	base64InsuranceDocument?: string;
	fetchSoftwareDocument: () => Promise<void>;
	fetchBankDocument: () => Promise<void>;
	fetchInsurancePersonalDocument: () => Promise<void>;
	fetchInsuranceDocument: () => Promise<void>;
}

export const useFetchDocument = (props: UseFetchDocumentInput): useFetchDocumentOutput => {
	const { reference } = props;
	const { fetch: fetchRetrieveSoftwareDocumentsReference } = useFetchSoftwareRetrieveDocumentsReference();
	const { fetch: fetchRetrieveBankDocumentsReference } = useFetchBankRetrieveDocumentsReference();
	const { fetch: fetchRetrieveBankInsuranceDocumentReference } = useFetchBankInsuranceDocumentReference();
	const { fetch: fetchRetrieveBankInsurancePersonalDocumentReference } =
		useFetchBankInsurancePersonalDocumentReference();
	const {
		retrieveBankDocumentReference,
		retrieveSoftwareDocumentReference,
		retrieveBankInsuranceDocumentReference,
		retrieveBankInsurancePersonalDocumentReference,
	} = useServiceResponse();

	const getDocumentBase64 = (data: GetDocumentsReferenceOutputDto | null | undefined): string | undefined => {
		return data?.documentList?.[0]?.document || undefined;
	};

	const fetchSoftwareDocument = (): Promise<void> => {
		return new Promise((resolve) => {
			// only fetch 1x document
			if (retrieveSoftwareDocumentReference) {
				resolve();
			} else {
				fetchRetrieveSoftwareDocumentsReference({ reference }).then((res) => {
					resolve();
				});
			}
		});
	};

	const fetchBankDocument = (): Promise<void> => {
		return new Promise((resolve) => {
			// only fetch 1x document
			if (retrieveBankDocumentReference) {
				resolve();
			} else {
				fetchRetrieveBankDocumentsReference({ reference }).then((res) => {
					resolve();
				});
			}
		});
	};

	const fetchInsurancePersonalDocument = (): Promise<void> => {
		return new Promise((resolve) => {
			fetchRetrieveBankInsurancePersonalDocumentReference({ reference }).then((res) => {
				resolve();
			});
		});
	};

	const fetchInsuranceDocument = (): Promise<void> => {
		return new Promise((resolve) => {
			fetchRetrieveBankInsuranceDocumentReference({ reference }).then((res) => {
				resolve();
			});
		});
	};

	return {
		base64SoftwareDocument: getDocumentBase64(retrieveSoftwareDocumentReference),
		base64BankDocument: getDocumentBase64(retrieveBankDocumentReference),
		base64InsurancePersonalDocument: getDocumentBase64(retrieveBankInsurancePersonalDocumentReference),
		base64InsuranceDocument: getDocumentBase64(retrieveBankInsuranceDocumentReference),
		fetchSoftwareDocument,
		fetchBankDocument,
		fetchInsuranceDocument,
		fetchInsurancePersonalDocument,
	};
};
